<template>
  <div class="candidate-profile">
    <div v-if="loading.candidate" class="h-100 d-flex justify-center align-center">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>

    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <ProfileTopPanel v-if="candidate"
      userTypeName="Кандидат"
      :name="candidate.last_name + ' ' + candidate.first_name"
      :city="candidate.location"
      :age="age"
      :phone="candidate.phone"
      :telegram="candidate.telegram"
      :email="candidate.email"
      :position="candidate.position"
      :manager="candidate.manager ? candidate.manager.last_name + ' ' + candidate.manager.first_name :''"
      permssionEdit="edit_candidate"
      permssionDelete="delete_candidate"
      whoDelete="кандидата"
      @delete="onDelete()" @edit="onEdit()"
    >
      <div class="profile-header-item" style="margin-top:0">
        <v-switch v-if="!isProfile && $store.getters['auth/isAllowed']('edit_candidate')"
          :input-value="candidate.is_active" @change="changeActive" :loading="loading.edit" class="v-input--reverse profile-switch"
          hide-details :color="candidate.is_active ? 'success' : 'error'"
        >
          <div slot="label" :class="candidate.is_active ? 'success--text' : 'error--text'">{{candidate.is_active ? 'Активен' : 'Не активен'}}</div>
        </v-switch>
        <v-switch v-if="!isProfile && $store.getters['auth/isAllowed']('edit_candidate')"
          :input-value="candidate.send_mail" @change="changeSendMail"
          class="v-input--reverse profile-switch ml-4" hide-details :color="candidate.send_mail ? 'success' : 'error'"
        >
          <div slot="label" :class="candidate.send_mail ? 'success--text' : 'error--text'">Почта</div>
        </v-switch>
        <!-- <v-text-field label="Телеграм" :value="candidate.telegram" @input="$v.form.telegram.$touch()" class="ml-6 mt-6"
                        :error-messages="telegramErrors"
                        outlined dense /> -->
      </div>
    </ProfileTopPanel>

    <ProfileEditDialog />

    <div class="row">
      <div class="col-12 _col-lg-8">
        <div v-if="candidate" class="profile-board profile-card mb-5">
          <h3 class="mt-1 mb-3">Общая информация</h3>

          <v-btn v-for="(tab, ind) in visibleTabs" :key="ind" @click="setTab(ind)" class="mr-3 mb-2" :outlined="mainTab!==ind" color="primary" rounded>
            {{ tab.label }}
          </v-btn>

          <v-tabs-items :value="mainTab" class="mt-5">
            <v-tab-item v-for="(tab, ind) in visibleTabs" :key="ind">
              <component :is="tab.component" />
            </v-tab-item>
          </v-tabs-items>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileEditDialog from '@/components/profile/ProfileEditDialog';
import BreadCrumbs from '@/components/ui/BreadCrumbs';
import ProfileTopPanel from '@/components/common/ProfileTopPanel';
import ProfileTabAIExpert from '@/components/ai/expert/ExpertTab';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ProfileTabStatus from './ProfileTabStatus';
import ProfileTabReports from './ProfileTabReports';
import ProfileTabInfo from './ProfileTabInfo';
import ProfileTabDossier from './ProfileTabDossier';

export default {
  name: 'ProfileData',
  components: {
    ProfileEditDialog, ProfileTopPanel, ProfileTabStatus, ProfileTabReports, BreadCrumbs, ProfileTabInfo, ProfileTabDossier, ProfileTabAIExpert
  },
  props: ['userId'],
  data: () => ({
    mainTab: 0,
  }),
  provide() {
    return {
      userType: 'Candidate',
      userId: this.userId,
    };
  },
  inject: {
    isProfile: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      candidate: 'users/candidate/candidate',
      errors: 'users/candidate/errors',
      loading: 'users/candidate/loading',
    }),
    allTabs() {
      return [
        { label: 'Профиль', component: ProfileTabInfo, visible: this.$store.getters['auth/isAllowed']('view_candidate_tab_profile') },
        { label: 'Статус тестирования', component: ProfileTabStatus, visible: this.$store.getters['auth/isAllowed']('view_candidate_tab_status') },
        { label: 'Отчеты', component: ProfileTabReports, visible: this.$store.getters['auth/isAllowed']('view_candidate_tab_reports') },
        { label: 'AI-эксперт', component: ProfileTabAIExpert, visible: this.$store.getters['auth/isAllowed']('view_candidate_tab_aiexpert') },
        { label: 'Досье сотрудника', component: ProfileTabDossier, visible: this.$store.getters['auth/isAllowed']('view_candidate_tab_dossier') },
      ];
    },
    visibleTabs() {
      return this.allTabs.filter(tab => tab.visible);
    },
    breadcrumbs() {
      if (!this.candidate) return [];
      return this.isProfile ? [
        { title: 'Личный кабинет', url: '/' },
      ] : [
        { title: 'Кандидаты', url: '/candidates/' },
        { title: `${this.candidate.last_name} ${this.candidate.first_name}`, url: `/candidates/${this.candidate.id}` },
      ];
    },
    age() {
      if (this.candidate.date_of_birth) {
        const years = this.$moment().diff(this.candidate.date_of_birth, 'years');
        if (years) {
          return `${years} ${this.$declOfNum(years, 'год', 'года', 'лет')}`;
        }
      }
      return '';
    },
  },
  methods: {
    ...mapActions({
      deleteCandidate: 'users/candidate/deleteCandidate',
      setDialogEditShow: 'users/candidates/setDialogEditShow',
      setCandidateActive: 'users/candidate/setCandidateActive',
      setCandidateSendMail: 'users/candidate/setCandidateSendMail',
      loadCandidate: 'users/candidate/loadCandidate',
      loadCandidateResults: 'users/candidate/loadCandidateResults',
      resetStateCandidate: 'users/candidate/resetState',
      resetStateTabs: 'profile/tabs/resetState',
    }),
    ...mapMutations({
      setEditedCandidate: 'users/candidates/setEditedCandidate',
    }),
    onDelete() {
      this.deleteCandidate().then(() => {
        this.$router.replace({ name: 'candidates' });
      });
    },
    onEdit() {
      this.setEditedCandidate({ ...this.candidate });
      this.setDialogEditShow(true);
    },
    changeActive(value) {
      this.setCandidateActive({ is_active: !!value, id: this.candidate.id });
    },
    changeSendMail(value) {
      this.setCandidateSendMail({ send_mail: !!value, id: this.candidate.id });
    },
    setTab(tab) {
      this.mainTab = tab;
    },
  },
  created() {
    this.loadCandidate(this.userId);
    this.loadCandidateResults(this.userId);
  },
  beforeDestroy() {
    this.resetStateCandidate();
    this.resetStateTabs();
  },

};
</script>

<style lang="scss">
@import "src/assets/styles/variables";

.candidate-profile textarea {
  line-height: 125% !important;
}

</style>
